// 図面のマーカーに使う矢印の形。凡例でも同じ形を示す必要があるため、
// 描画する側とその見本を出す側の両方から参照できる場所に置く。
// Material Symbols Rounded の navigation アイコン（FILL=1）。
export const ARROW_MARKER_PATH = 'm200-120-40-40 320-720 320 720-40 40-280-120-280 120Z';
export const ARROW_MARKER_VIEWBOX = '0 -960 960 960';

// 図面上のマーカーと同じ輪郭にするための線の太さ（viewBox の座標系）。
export const ARROW_MARKER_STROKE_WIDTH = 60;

// 凡例では真上ではなく斜めに倒して見せる。図面上のマーカーは配置ごとに
// 向きが変わるため、特定の向きを正面として示さない。
export const ARROW_MARKER_LEGEND_TRANSFORM = 'rotate(-30 480 -480)';
